import Api from "./Api";
// import ConfigModel from "@/model/Config";
import { AxiosRequestConfig, AxiosResponse } from "axios";

import { ConfigServerResponse } from "@/types/global.d";

class ConfigApi extends Api {
  public constructor(config?: AxiosRequestConfig) {
    super(config);
  }

  public getConfig(): Promise<ConfigServerResponse> {
    const url = this.prepareUrl("/disclosurecode/public/config/");
    return this.get<ConfigServerResponse, AxiosResponse<ConfigServerResponse>>(
      url
    ).then(this.success);
  }
}

export default new ConfigApi();
